import { injectGlobal } from "styled-components";

/* eslint no-unused-expressions: 0 */
injectGlobal`
    * {
        border: 0;
        box-sizing: inherit;
        -webkit-font-smoothing: antialiased;
        font-weight: inherit;
        margin: 0;
        outline: 0;
        padding: 0;
        text-rendering: optimizeLegibility;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    html {
        display: flex;
        height: 100%;
        width: 100%;
        max-height: 100%;
        max-width: 100%;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.5;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: 100%;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
            sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    }

    body {
        display: flex;
        box-sizing: border-box;
        flex: auto;
        align-self: stretch;
        max-width: 100%;
        max-height: 100%;
        -webkit-overflow-scrolling: touch;
        color: #141414;
    }

    #root {
        display: flex;
        display: -webkit-box;
        display: -webkit-flex
        display: -moz-flex;
        display: -ms-flexbox;
        flex-direction: column;
        -ms-flex-direction: column;
        -moz-flex-direction: column;
        -webkit-flex-direction: column;
        height: 100%;
        width: 100%;
    }

    #root, #root > div, #root > div  {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    a {
        color: currentColor;
        text-decoration: none;
    }

    h1 {
        font-family: "utopia-std-display", georgia, times, serif;
        font-style: normal;
        font-weight: 400;
    }

    .highlight {
        box-shadow: inset 0 -16px 0 0px cyan;
    }

    h1 {
        animation: blur-skew 2s ease;
    }

    ul {
        padding: 0;
        margin: 0;
        list-style-type: none;
    }

    li {
        display: block;
    }
`;



// WEBPACK FOOTER //
// ./src/reset.css.js